import { render, staticRenderFns } from "./link.md?vue&type=template&id=2f718478"
import script from "./link.md?vue&type=script&lang=js"
export * from "./link.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports